import { axiosInstance } from '../App';
import {
    FinancialAccountDTO,
    CreateFinancialAccountDTO,
    UpdateFinancialAccountDTO,
    MovementResponseDTO,
    MovementTypeOption,
    PaginatedMovementsDTO,
    ListMovementsParams,
    CreateMovementRequestDTO,
    TransferRequestDTO,
    PaymentMethodDTO,
    AssociatePaymentMethodRequestDTO,
    BalanceCorrectionRequestDTO,
} from '../dto/FinancialAccountDTO';

const BASE_ACCOUNTS = '/api/secured/financial-accounts';
const BASE_MOVEMENTS = '/api/secured/financial-account-movements';

export function getAllFinancialAccounts(): Promise<FinancialAccountDTO[]> {
    return axiosInstance.get(BASE_ACCOUNTS).then(r => r.data);
}

export function getMovementTypes(): Promise<MovementTypeOption[]> {
    return axiosInstance.get(`${BASE_MOVEMENTS}/types`).then(r => r.data);
}

export function createFinancialAccount(body: CreateFinancialAccountDTO): Promise<FinancialAccountDTO> {
    return axiosInstance.post(BASE_ACCOUNTS, body).then(r => r.data);
}

export function getBalance(accountId: number): Promise<number> {
    return axiosInstance.get(`${BASE_MOVEMENTS}/${accountId}/balance`).then(r => r.data);
}

export function listMovements(params: ListMovementsParams): Promise<PaginatedMovementsDTO> {
    return axiosInstance.get(BASE_MOVEMENTS, {
        params,
    }).then(r => r.data);
}

export function createMovement(body: CreateMovementRequestDTO): Promise<MovementResponseDTO> {
    return axiosInstance.post(BASE_MOVEMENTS, body).then(r => r.data);
}

export function createBalanceCorrection(accountId: number, body: BalanceCorrectionRequestDTO): Promise<MovementResponseDTO> {
    return axiosInstance.post(`${BASE_MOVEMENTS}/${accountId}/balance-correction`, body).then(r => r.data);
}

export function createTransfer(body: TransferRequestDTO): Promise<void> {
    return axiosInstance.post(`${BASE_MOVEMENTS}/transfer`, body).then(r => r.data);
}

export function updateFinancialAccount(accountId: number, body: UpdateFinancialAccountDTO): Promise<FinancialAccountDTO> {
    return axiosInstance.put(`${BASE_ACCOUNTS}/${accountId}`, body).then(r => r.data);
}

export function getAllPaymentMethods(): Promise<PaymentMethodDTO[]> {
    return axiosInstance.get(`${BASE_ACCOUNTS}/payment-methods`).then(r => r.data);
}

export function getAccountPaymentMethods(accountId: number): Promise<PaymentMethodDTO[]> {
    return axiosInstance.get(`${BASE_ACCOUNTS}/${accountId}/payment-methods`).then(r => r.data);
}

export function associatePaymentMethod(accountId: number, body: AssociatePaymentMethodRequestDTO): Promise<void> {
    return axiosInstance.post(`${BASE_ACCOUNTS}/${accountId}/payment-methods`, body).then(r => r.data);
}

export function disassociatePaymentMethod(accountId: number, paymentMethodId: number): Promise<void> {
    return axiosInstance.delete(`${BASE_ACCOUNTS}/${accountId}/payment-methods/${paymentMethodId}`).then(r => r.data);
}
